module.exports = __webpack_public_path__ + "img/conhome-full-logo-pink.3c55322d.svg";